import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import Subheading from "../Common/Subheading";
import BillingDetails from "./BillingDetails";
import AccountContacts from "./AccountContacts";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import {
  useGetBillingSettingsDataQuery,
  useUpdateBillingSettingsDataMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { isUserPermitted } from "../helpers/pageProps";

function BillingSettings() {
  const canEdit = isUserPermitted("access_billing");
  const [billingSettings, setBillingSettings] = useState({});
  const { data } = useGetBillingSettingsDataQuery();
  const [saveData] = useUpdateBillingSettingsDataMutation();
  const [errors, setErrors] = useState({});

  const handleSave = async () => {
    setErrors({});
    const res = await saveData(billingSettings);
    console.log(res);
    if (res.error) {
      toast.error(res.error.data.message);
      setErrors(res.error.data.errors);
      return;
    }
    toast.success("Settings saved successfully");
  };
  useEffect(() => {
    if (!data) return;
    setBillingSettings(data);
  }, [data]);
  useEffect(() => {
    if (!data) return;
    setBillingSettings(data);
  }, [data]);

  const handleBillingChange = (e) =>
    setBillingSettings((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  return (
    <div className="mb-5">
      <Subheading
        Icon={BillingDetailsIcon}
        heading="Billing Settings"
        subheading="Your pre-defined Billing settings"
      />
      <Form>
        <fieldset disabled={!canEdit} className="border-0 p-0 m-0">
        <Row xs={1} xl={2}>
          <Col>
            <BillingDetails
              handleBillingChange={handleBillingChange}
              billingSettings={billingSettings}
              errors={errors}
            />
          </Col>
          <Col>
            <AccountContacts
              handleAccountChange={handleBillingChange}
              accountsContact={billingSettings}
              errors={errors}
            />
          </Col>
        </Row>
        <hr className="my-5 text-secondary" />
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-colored-reverse rounded-pill fw-bold "
            onClick={handleSave}
            disabled={!canEdit}
          >
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
            SAVE SETTINGS
          </button>
        </div>
        </fieldset>
      </Form>
    </div>
  );
}

export default BillingSettings;
